import React, { useCallback, useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import { InputFormGroup, LineByLineFormGroup } from '@bingads-webui-cc-react/layout';
import { Input } from '@bingads-webui-react/primitive-validation';
import { TaxUtils } from '@bingads-webui-clientcenter/entity-utils';
import { validateField, ValidateItems, CustomValidateItems } from '../validator';
import { useValidationI18n } from '../hooks/use-i18n';

const { isCOCertExecutionDateValid } = TaxUtils;

const ExecutionDateSchema = {
  properties: {
    executionDate: {
      type: 'string',
    },
  },
};

export const TaxCertificateExecutionDate = ({
  i18n,
  executionDate,
  onExecutionDateChange,
  showLineByLineFormGroup,
  alwaysShowError,
  disabled,
}) => {
  const validationI18n = useValidationI18n(i18n);
  const CustomizedFormGroup = showLineByLineFormGroup ? LineByLineFormGroup : InputFormGroup;

  const onExecutionDateValidate = useCallback(({ data, isValid }) => {
    onExecutionDateChange({
      executionDate: data.executionDate,
      isValid,
    });
  }, [onExecutionDateChange]);

  // Clear data when unmount
  // useLayoutEffect to make sure it runs before the next component's effect
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useLayoutEffect(() => () => onExecutionDateChange({ executionDate: null, isValid: true }), []);

  return (
    <CustomizedFormGroup
      isStatic
      label={i18n.getString(_TL_('Execution date'))}
      className="tax-cert-execution-date"
    >
      <Input
        id="execution-date"
        disabled={disabled}
        validationProps={{
          i18n: validationI18n,
          alwaysShowError,
          onValidate: onExecutionDateValidate,
          field: 'executionDate',
          data: { executionDate },
          schema: ExecutionDateSchema,
          validator: value => validateField(
            value,
            { [ValidateItems.Required]: { isRequired: true } },
            { [CustomValidateItems.ColombiaCertificationExecutionDateValidation]: inputValue => !isCOCertExecutionDateValid(inputValue) },
            i18n
          ),
        }}
      />
    </CustomizedFormGroup>
  );
};

TaxCertificateExecutionDate.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  onExecutionDateChange: PropTypes.func.isRequired,
  executionDate: PropTypes.string,
  showLineByLineFormGroup: PropTypes.bool,
  alwaysShowError: PropTypes.bool,
  disabled: PropTypes.bool,
};

TaxCertificateExecutionDate.defaultProps = {
  executionDate: null,
  showLineByLineFormGroup: false,
  alwaysShowError: false,
  disabled: false,
};
